import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MAbbreviateCardIconComponent } from './abbreviate-card-icon.component';
import { MAbbreviateCardComponent } from './abbreviate-card.component';

@NgModule({
  imports: [CommonModule, FormsModule, NzIconModule, NzOutletModule],
  exports: [MAbbreviateCardComponent, MAbbreviateCardIconComponent],
  declarations: [MAbbreviateCardComponent, MAbbreviateCardIconComponent]
})
export class MAbbreviateCardModule {}
